import React from 'react'
import {useParams} from 'react-router-dom'
export default function App17() {
  const {id}=useParams()
  return (
    <div>列表页{id}</div>
  )
}
